import { Module } from 'vuex';
import { RootState } from '../types';
import { getters } from './_getters';
import { actions } from './_actions';
import { mutations } from './_mutations';
import { CampaignState } from './types';

export const state: CampaignState = {
    currentCampaign: {
        id: '',
        name: '',
        app: null,
    },
    currentAdset: {
        idList: [],
        name: '',
    },
};

const namespaced: boolean = true;

export const Campaign: Module<CampaignState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
